import { isEmpty } from "lodash";

export default class httpServiceShops {

  static async get(resource, params = {}) {
    let newResource = `${ENV.SHOPS_BASE_URL}/api/v1/${resource}`;

    if (!isEmpty(params)) {
      newResource = `${newResource}?${new URLSearchParams(params).toString()}`;
    }

    const options = {
      method: 'GET',
      headers: setHeader()
    };

    const response = await fetch(newResource, options).catch(handleFetchError);
    const json = await response.json().catch(handleParsingError);

    checkResponse(response, json);
    return json;
  }

  static async post(resource, params = {}) {
    resource = `${ENV.SHOPS_BASE_URL}/api/v1/${resource}`;
    const options = {
      method: 'POST',
      headers: setHeader(),
      body: JSON.stringify(params)
    }

    const response = await fetch(resource, options).catch(handleFetchError);
    const json = await response.json().catch(handleParsingError);

    checkResponse(response, json);
    return json;
  }

  static async put(resource, params = {}) {
    resource = `${ENV.SHOPS_BASE_URL}/api/v1/${resource}`;
    const options = {
      method: 'PUT',
      headers: setHeader(),
      body: JSON.stringify(params)
    }

    const response = await fetch(resource, options).catch(handleFetchError);
    const json = await response.json().catch(handleParsingError);

    checkResponse(response, json);
    return json;
  }

  static async remove(resource, params = {}) {
    resource = `${ENV.SHOPS_BASE_URL}/api/v1/${resource}`;
    const options = {
      method: 'DELETE',
      headers: setHeader(),
      body: JSON.stringify(params)
    }

    const response = await fetch(resource, options).catch(handleFetchError);
    const json = await response.json().catch(handleParsingError);

    checkResponse(response, json);
    return json;
  }
}

function setHeader() {
  let headers = {
    'Accept': "application/json, text/plain",
    'Content-Type': 'application/json',
    'MERCATELY-AUTH-TOKEN': ENV.MERCATELY_AUTH_TOKEN,
    'RETAILER-KEY': ENV.UNIQUE_KEY
  }

  return headers;
}

function checkResponse(response, json) {
  if (response.status !== 200) {
    throw {
      errors: json.message || json.errors,
      status: response.status
    };
  }
}

function handleFetchError(error) {
  console.log("ERROR FETCHING: ", error);
  throw "We were unable to connect to the server";
}

function handleParsingError(error) {
  console.log("ERROR PARSING JSON: ", error);
  throw "There was an error reading the response from the server";
}
